module.exports = __webpack_public_path__ + "static/media/thum1.57ef91e9.jpg";